/**
 * Sprint V100 — Vorab-Frage: Beruflich vs. Privat.
 * Pflicht-Auswahl, kein „Beides".
 */
import React from "react";

export default function QuickCheckContextChooser({ onSelect }) {
  return (
    <div className="max-w-2xl mx-auto text-center" data-testid="v100-context-chooser">
      <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white">
        Wofür möchtest du dein Muster besser verstehen?
      </h2>
      <p className="mt-3 text-sm sm:text-base text-slate-600 dark:text-slate-300">
        Wähl eine Richtung — die Situationen sind darauf abgestimmt.
      </p>
      <div className="mt-8 grid sm:grid-cols-2 gap-4">
        <button
          type="button"
          onClick={() => onSelect("beruflich")}
          data-testid="v100-context-beruflich"
          className="group rounded-2xl border-2 border-slate-200 dark:border-slate-700 hover:border-[#4563BB] dark:hover:border-[#4563BB] bg-white dark:bg-slate-800 hover:bg-[#4563BB]/[0.03] p-6 text-left transition-all"
        >
          <div className="text-xs font-bold uppercase tracking-widest text-[#4563BB]">
            Beruflich
          </div>
          <div className="mt-2 text-lg font-bold text-slate-900 dark:text-white">
            Für berufliche Situationen
          </div>
          <div className="mt-1 text-sm text-slate-600 dark:text-slate-300">
            Team, Kunden, Vorgesetzte.
          </div>
          <div className="mt-4 text-sm text-[#4563BB] font-semibold group-hover:underline">
            Los geht&apos;s &rarr;
          </div>
        </button>

        <button
          type="button"
          onClick={() => onSelect("privat")}
          data-testid="v100-context-privat"
          className="group rounded-2xl border-2 border-slate-200 dark:border-slate-700 hover:border-[#F3651D] dark:hover:border-[#F3651D] bg-white dark:bg-slate-800 hover:bg-[#F3651D]/[0.03] p-6 text-left transition-all"
        >
          <div className="text-xs font-bold uppercase tracking-widest text-[#F3651D]">
            Privat
          </div>
          <div className="mt-2 text-lg font-bold text-slate-900 dark:text-white">
            Für private Situationen
          </div>
          <div className="mt-1 text-sm text-slate-600 dark:text-slate-300">
            Beziehung, Familie, Freunde.
          </div>
          <div className="mt-4 text-sm text-[#F3651D] font-semibold group-hover:underline">
            Los geht&apos;s &rarr;
          </div>
        </button>
      </div>
    </div>
  );
}
